import React, { useState, useEffect } from "react";
import { Card } from "react-bootstrap";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Defs,
  LinearGradient,
} from "recharts";
import axios from "axios";

const SalesChart = () => {
  const [hourlyData, setHourlyData] = useState([]);

  useEffect(() => {
    axios
      .get("./dati_dashboard.json")
      .then((res) => setHourlyData(res.data.AR.orario))
      .catch((err) => console.error(err));
  }, []);

  const maxYValue = Math.max(...hourlyData.map((d) => d.valore), 0) + 1000;

  const formatEuro = (val) =>
    new Intl.NumberFormat("it-IT", {
      style: "currency",
      currency: "EUR",
      maximumFractionDigits: 0,
    }).format(val);

  return (
    <Card
      className="card bg-dark ombra card-home graphic-day hover-effect border-0 am-chart-card"
      style={{ borderRadius: "15px", padding: "1rem" }}
    >
      <div className="d-flex justify-content-between align-items-center px-3 am-chart-header">
        <h6
          className="text-title2 fw-bold mb-0"
          style={{ letterSpacing: "1px" }}
        >
          ORDINI PER ORA
        </h6>
        <span className="badge rounded-pill bg-light text-dark border">
          Oggi
        </span>
      </div>

      <div className="am-chart-body">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart
            data={hourlyData}
            margin={{ top: 10, right: 10, left: 0, bottom: 0 }}
          >
            <defs>
              {/* Gradiente sotto la linea */}
              <linearGradient id="colorValue" x1="0" y1="0" x2="0" y2="1">
                <stop
                  offset="5%"
                  stopColor="rgba(241,111,36,1)"
                  stopOpacity={0.3}
                />
                <stop
                  offset="95%"
                  stopColor="rgba(241,111,36,1)"
                  stopOpacity={0}
                />
              </linearGradient>
            </defs>

            <CartesianGrid
              strokeDasharray="3 3"
              vertical={false}
              stroke="#333333"
            />

            <XAxis
              dataKey="orario"
              axisLine={false}
              tickLine={false}
              tick={{ fill: "#999", fontSize: 11 }}
              dy={10}
            />

            <YAxis
              // 1. Rimuoviamo 'hide' per rendere visibile l'asse
              domain={[0, maxYValue]}
              // 2. Usiamo la tua funzione formatEuro per formattare i numeri
              tickFormatter={formatEuro}
              // 3. Impostiamo una larghezza per evitare che i prezzi lunghi vengano tagliati
              width={80}
              axisLine={false}
              tickLine={false}
              tick={{ fill: "#999", fontSize: 11 }}
            />

            <Tooltip
              contentStyle={{
                borderRadius: "10px",
                border: "none",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                fontSize: "13px",
              }}
              formatter={(value) => [formatEuro(value), "Vendite"]}
              cursor={{
                stroke: "rgba(241,111,36,1)",
                strokeWidth: 1,
                strokeDasharray: "5 5",
              }}
            />

            <Area
              type="monotone"
              dataKey="valore"
              stroke="rgba(241,111,36,1)"
              strokeWidth={3}
              fillOpacity={1}
              fill="url(#colorValue)"
              animationBegin={0}
              animationDuration={1500}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
};

export default SalesChart;
